
const steps = [
  { n: '01', title: 'Request a quote', text: 'Share your property, service needs, and any photos that help us scope the job quickly.' },
  { n: '02', title: 'Get a clear plan', text: 'Receive a practical recommendation for mowing, gardening, weed control, or acreage.' },
  { n: '03', title: 'Enjoy the finish', text: 'Our crew completes the work with crisp lines, thorough cleanup, and reliable communication.' },
];

export default function Process() {
  return (
    <section id="process" className="py-24 cream-bg">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14 reveal">
          <p className="section-label mb-4">How It Works</p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-[1.05]">
            A cleaner process from first quote to recurring care.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {steps.map((s, i) => (
            <div key={s.n} className="reveal gold-top-card p-8" style={{ transitionDelay: `${i * 100}ms` }}>
              <div className="text-[#1B6E37] font-bold text-sm tracking-widest mb-4">{s.n}</div>
              <h3 className="text-2xl font-bold mb-3" style={{ fontFamily: 'Inter, sans-serif' }}>{s.title}</h3>
              <p className="text-[#212B20] leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
